// extracted by mini-css-extract-plugin
export default {"pricingCard":"style_pricingCard__RDPjg","price":"style_price__NFCwR","description":"style_description__rHa36","btn":"style_btn__ypOt3"};